<template>
  <el-row class="container">
    <!-- header -->
    <el-col :span="24" class="header">
      <el-col :span="10" class="logo" :class="collapsed?'logo-collapse-width':'logo-width'">
        <router-link to="/">
          <img src="../assets/img/logo.png" alt>
        </router-link>
      </el-col>
      <!-- <el-col :span="4">
        <div class="tools" @click.prevent="collapse">
          <i class="fa fa-align-justify"></i>
        </div>
      </el-col>-->
      <el-col :span="10" class="userinfo">
        <el-menu class="docMenu3" mode="horizontal">
          <el-submenu index="1">
            <template slot="title"><span>{{$t("index.documentation")}}</span></template>
            <el-menu-item index="1-1"><a href="../../static/apidoc/docs.html" target="_blank">API</a></el-menu-item>
            <el-submenu class="subMenu" index="1-2">
              <template slot="title">SDK</template>
              <el-menu-item index="1-2-1"><a href="https://github.com/wanchain/iWan-js-sdk" target="_blank">JavaScript</a></el-menu-item>
              <el-menu-item index="1-2-2"><a href="https://github.com/wanchain/iWan-java-sdk" target="_blank">Java</a></el-menu-item>
            </el-submenu>
          </el-submenu>
        </el-menu>
        <el-dropdown-item class="logout" @click.native="logout">{{$t("index.logout")}}</el-dropdown-item>
      </el-col>
    </el-col>
    <el-col :span="24" class="main">
      <!-- left nav -->
      <aside :class="collapsed?'menu-collapsed':'menu-expanded'">
        <!--导航菜单-->
        <el-menu
          theme="dark"
          :default-active="$route.path"
          class="el-menu-vertical-demo"
          @open="handleopen"
          @close="handleclose"
          @select="handleselect"
          unique-opened
          router
          v-show="!collapsed"
        >
          <template v-for="(item,index) in $router.options.routes" v-if="isVisible(item)">
            <el-submenu :index="index+''" v-if="!item.leaf">
              <template slot="title">
                <i :class="item.iconCls"></i>
                {{$t(item.title)}}
              </template>
              <el-menu-item
                v-for="child in item.children"
                :index="child.path"
                :key="child.path"
                v-if="!child.hidden"
              >{{$t(child.title)}}</el-menu-item>
            </el-submenu>
            <el-menu-item v-if="item.leaf&&item.children.length>0" :index="item.children[0].path">
              <i :class="item.iconCls"></i>
              {{$t(item.children[0].title)}}
            </el-menu-item>
          </template>
        </el-menu>
        <!--导航菜单-折叠后-->
        <ul class="el-menu el-menu-vertical-demo collapsed" v-show="collapsed" ref="menuCollapsed">
          <li
            v-for="(item,index) in $router.options.routes"
            v-if="!item.hidden"
            class="el-submenu item"
          >
            <template v-if="!item.leaf">
              <div
                class="el-submenu__title"
                style="padding-left: 20px;color:#dadada!important;"
                @mouseover="showMenu(index,true)"
                @mouseout="showMenu(index,false)"
              >
                <i :class="item.iconCls"></i>
              </div>
              <ul
                class="el-menu submenu"
                :class="'submenu-hook-'+index"
                @mouseover="showMenu(index,true)"
                @mouseout="showMenu(index,false)"
              >
                <li
                  v-for="child in item.children"
                  v-if="!child.hidden"
                  :key="child.path"
                  class="el-menu-item"
                  style="padding-left: 40px;"
                  :class="$route.path==child.path?'is-active':''"
                  @click="$router.push(child.path)"
                >{{$t(child.name)}}</li>
              </ul>
            </template>
            <template v-else>
              <li class="el-submenu">
                <div
                  class="el-submenu__title el-menu-item"
                  style="padding-left: 20px;color:#dadada!important;height: 56px;line-height: 56px;padding: 0 20px;"
                  :class="$route.path==item.children[0].path?'is-active':''"
                  @click="$router.push(item.children[0].path)"
                >
                  <i :class="item.iconCls"></i>
                </div>
              </li>
            </template>
          </li>
        </ul>
      </aside>
      <section class="content-container">
        <div class="grid-content bg-purple-light">
          <!-- <el-col :span="24" class="breadcrumb-container">
            <strong class="title">{{$route.name}}</strong>
          </el-col>-->
          <el-col :span="24" class="content-wrapper">
            <transition name="fade" mode="out-in">
              <router-view></router-view>
            </transition>
          </el-col>
        </div>
      </section>
    </el-col>
  </el-row>
</template>

<script>
import { doLogout } from "../request";
export default {
  data() {
    return {
      collapsed: false,
      isAdmin: false
    };
  },
  methods: {
    handleopen() {},
    handleclose() {},
    handleselect: function(a, b) {},
    logout: function() {
      var _this = this;
      this.$confirm(
        this.$t("index.logoutWndInfo"),
        this.$t("common.reminder"),
        {
          //type: 'warning'
          showCancelButton: true,
          confirmButtonText: this.$t("index.logout"),
          cancelButtonText: this.$t("common.cancel")
        }
      )
        .then(() => {
          doLogout(this, {});
        })
        .catch(() => {});
    },
    isVisible: function(item) {
      if (item.hidden) {
        return false;
      }
      if (item.adminOnly) {
        if (!this.isAdmin) {
          return false;
        }
      }
      return true;
    }
    //
    //折叠导航栏
    // collapse: function() {
    //   this.collapsed = !this.collapsed;
    // },
    // showMenu(i, status) {
    //   this.$refs.menuCollapsed.getElementsByClassName(
    //     "submenu-hook-" + i
    //   )[0].style.display = status ? "block" : "none";
    // }
  },
  mounted() {
    this.isAdmin = (sessionStorage.getItem("role") === "admin");
  }
};
</script>

<style lang="scss">
.docMenu3 {
  > .el-submenu {
    > .el-submenu__title {
      padding: 0px;
    }
    .el-submenu__title:hover {
      border: none;
      background: transparent;
      opacity: 0.7;
    }
    span {
      color: #606e85;
    }
    .el-icon-caret-bottom {
      color: #606e85 !important;
      &:before {
        content: "\E600";
      }
    }
  }
  .el-submenu {
    > .el-menu {
      top: 20px;
      left: 0px;
      border: none;
      background-color: #b6b6b6;
      min-width: 130px;
    }
    .el-submenu__icon-arrow {
      margin-left: 7px;
      margin-top: 4px;
    }
  }
  .subMenu {
    .el-submenu__title {
      padding: 0px 10px;
      line-height: 36px !important;
    }
    > .el-submenu__title {
      font-size: 14px !important;
      display: inline-block;
      width: 100%;
    }
    .el-submenu__icon-arrow {
      position: absolute;
      margin-top: -7px !important;
      right: 10px;
    }
    >.el-menu {
      top: -6px;
      left: 130px !important;
    }
    .el-icon-caret-bottom:before {
      content: "\E602";
    }
  }
  .el-submenu__title {
    color: white;
    border: none !important;
    height: 100% !important;
    line-height: 16px !important;
    font-size: 16px;
    &:hover {
      background: rgba(42, 35, 35, .7);
    }
  }
}
</style>

<style lang="scss" scoped>
@import "~scss_vars";

.docMenu3 {
  display: inline-block;
  background: transparent;
  color: #606e85;
  top: 2px;
  .el-submenu {
    text-align: left;
    .el-menu-item {
      text-align: left;
      background-color: transparent;
      min-width: 130px;
      float: left;
      &:hover {
        background-color: rgba(42, 35, 35, .7);
      }
    }
    .el-menu-item.is-active {
      background-image: none !important;
    }
  }
  > .el-submenu {
    > .el-menu a {
      font-size: 14px !important;
      display: inline-block;
      width: 100%;
    }
  }
  .subMenu {
    width: 100%;
    height: 36px;
    line-height: 36px;
    a {
      font-size: 14px !important;
      display: inline-block;
      width: 100%;
    }
  }
}
.container .header .userinfo li.logout {
  color: #606e85;
  text-align: left;
}


.menu-expanded {
  flex: 0 0 180px;
  width: 180px;
  .el-menu {
    width: 100% !important;
  }
  .el-submenu .el-menu-item {
    min-width: 0px !important;
    background: $color-primary;
  }
}
.container {
  position: absolute;
  top: 0px;
  bottom: 0px;
  width: 100%;
  .header {
    height: 80px;
    line-height: 80px;
    color: #fff;
    margin-bottom: 50px;
    box-shadow: 0px 2px 10px 0px rgba(9, 45, 105, 0.04);
    background: #fff;
    position: relative;
    z-index: 10001;
    .userinfo {
      text-align: right;
      padding-right: 160px;
      float: right;
      li {
        color: white;
        font-size: 16px;
        display: inline-block;
        a {
          color: white;
          font-size: 16px;
        }
      }
      .userinfo-inner {
        cursor: pointer;
        color: #fff;
        img {
          width: 40px;
          height: 40px;
          border-radius: 20px;
          margin: 10px 0px 10px 10px;
          float: right;
        }
      }
    }
    .logo {
      height: 80px;
      font-size: 22px;
      padding-left: 20px;
      padding-right: 20px;
      border-color: $color-primary;
      border-right-style: solid;
      box-shadow: 3px 0px 10px 0px rgba(9, 45, 105, 0.3);
      background: $color-primary;
      img {
        width: 110px;
        float: left;
        margin: 16px auto 18px;
      }
      .txt {
        color: #fff;
      }
    }
    .logo-width {
      width: 230px;
    }
    .logo-collapse-width {
      width: 60px;
    }
    .tools {
      padding: 0px 23px;
      width: 14px;
      height: 80px;
      line-height: 80px;
      cursor: pointer;
    }
  }
  .main {
    display: flex;
    position: absolute;
    top: 80px;
    bottom: 0px;
    aside {
      flex: 0 0 230px;
      width: 230px;

      .el-menu {
        height: 100%;
        border-radius: 0;
        box-shadow: 3px 0px 10px 0px rgba(9, 45, 105, 0.3);
        background: $color-primary;
      }
      .collapsed {
        width: 60px;
        .item {
          position: relative;
        }
        .submenu {
          position: absolute;
          top: 0px;
          left: 60px;
          z-index: 99999;
          height: auto;
          display: none;
        }
      }
    }
    .menu-collapsed {
      flex: 0 0 60px;
      width: 60px;
    }
    .menu-expanded {
      flex: 0 0 230px;
      width: 230px;
    }
    .content-container {
      flex: 1;
      margin: 0 0 0px;
      // overflow-y: scroll;
      overflow: auto;
      .breadcrumb-container {
        .title {
          width: 200px;
          float: left;
          color: #475669;
        }
        .breadcrumb-inner {
          float: right;
        }
      }
      .content-wrapper {
        background-color: #f8f9fa !important;
        box-sizing: border-box;
      }
    }
  }
}




</style>


// WEBPACK FOOTER //
// Home.vue?889398a2